module.exports = __webpack_public_path__ + "img/kid-throwing-football.23a94a3.svg";